export default "/_next/static/chunks/fonts/WhitneySSm-Semibold-Pro_Web-acd636d43906b69e839b52de4a4639df.woff";